<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <IntegratorForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import IntegratorForm from '@/components/settings/integrador/integrator/IntegratorForm'

export default {
  name: 'IntegratorAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    IntegratorForm
  }
}
</script>
